import * as Phaser from "phaser";
import { TextButton } from "$/game/prefabs/ui/TextButton.ts";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export const createSceneSwitcher = (scene: BasicScene) => {
  if (!scene.global.TUNER_TWA_CONFIG.isDev) return;

  const { width, height } = scene.scale;
  const container = scene.add.container(width / 2, height - 15);

  const b1 = new TextButton(
    scene,
    -50,
    0,
    "1",
    () => {
      console.log("EggBrake button clicked!");
      scene.transition.toScene("EggBrakeScene", "Brake the egg!");
    },
    {
      fontSize: "15",
    },
  );

  container.add(b1);

  const b2 = new TextButton(
    scene,
    -25,
    0,
    "2",
    () => {
      console.log("EggBrake button clicked!");
      scene.transition.toScene("PetHomeScene", "Home...");
    },
    {
      fontSize: "15",
    },
  );

  container.add(b2);

  const b3 = new TextButton(
    scene,
    0,
    0,
    "3",
    () => {
      console.log("EggBrake button clicked!");
      scene.transition.toScene("PetDeathScene", "Oh no...");
    },
    {
      fontSize: "15",
    },
  );

  container.add(b3);

  const b4 = new TextButton(
    scene,
    25,
    0,
    "4",
    () => {
      console.log("EggBrake button clicked!");
      scene.transition.toScene("CurrencyShopScene", "Shop <3");
    },
    {
      fontSize: "15",
    },
  );

  container.add(b4);

  const b5 = new TextButton(
    scene,
    50,
    0,
    "5",
    () => {
      console.log("EggBrake button clicked!");
      scene.transition.toScene("PetCreateScene", "Choose Your Pet ^_^");
    },
    {
      fontSize: "15",
    },
  );

  container.add(b5);

  const b6 = new TextButton(
    scene,
    75,
    0,
    "6",
    () => {
      console.log("Catch Food Game button clicked!");
      scene.transition.toScene("CatchFoodGameScene", "Catch the food!");
    },
    {
      fontSize: "15",
    },
  );

  container.add(b6);
};
